<div *transloco="let t" id="filter-container-root">

  <mat-chip-list>

    <mat-chip
      [matMenuTriggerFor]="chipMultiCheckboxMenu"
      #chipMultiMenuButton="matMenuTrigger"
      *ngIf="this.filterArray"
      disableRipple>

      <div *ngIf="!getSelectedChips().length">{{filterName}}</div>
      <div *ngIf="getSelectedChips().length" class="selected-regions">
        {{ getSelectedChips().length }} selected
      </div>

      <mat-icon
        [ngClass]="{
          'menu-open': chipMultiMenuButton.menuOpen,
          'menu-close': !chipMultiMenuButton.menuOpen
        }"
      >
        keyboard_arrow_down
      </mat-icon>

    </mat-chip>

    <mat-menu
      #chipMultiCheckboxMenu="matMenu"
      class="filters-region"
      yPosition="below"
    >
      <div class="regions">
        <mat-chip
          *ngFor="let chip of chips"
          [selected]="chip.isActive"
          (click)="onChipSelectionChange(chip, $event)"
        >
          <nb-icon icon="square-outline" *ngIf="!chip.isActive"></nb-icon>
          <nb-icon
            icon="checkmark-square-2"
            *ngIf="chip.isActive"
            class="selected"
          ></nb-icon>
          {{ t(chip.filterType!) | titlecase }}
        </mat-chip>
      </div>
    </mat-menu>

  </mat-chip-list>

</div>
